var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnSelectedLeaderBoardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_632_168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7672 10.4719L16.1672 9.06563C16.0391 9.01562 15.7734 8.95 15.4734 9.06563L11.8734 10.4719C11.5391 10.6031 11.3203 10.9094 11.3203 11.25C11.3203 14.7375 13.4672 17.15 15.4734 17.9344C15.7734 18.05 16.0359 17.9844 16.1672 17.9344C17.7703 17.3094 20.3203 15.1406 20.3203 11.25C20.3203 10.9094 20.1016 10.6031 19.7672 10.4719ZM15.8203 16.45V10.5406L18.8047 11.7063C18.6297 14.4281 16.9016 15.9375 15.8203 16.45ZM7.32031 10C9.52969 10 11.3203 8.20937 11.3203 6C11.3203 3.79063 9.52969 2 7.32031 2C5.11094 2 3.32031 3.79063 3.32031 6C3.32031 8.20937 5.11094 10 7.32031 10ZM10.3203 11.25C10.3203 11.1719 10.3453 11.1 10.3547 11.025C10.2766 11.0219 10.2016 11 10.1203 11H9.59844C8.90469 11.3188 8.13281 11.5 7.32031 11.5C6.50781 11.5 5.73906 11.3188 5.04219 11H4.52031C2.20156 11 0.320312 12.8813 0.320312 15.2V16.5C0.320312 17.3281 0.992188 18 1.82031 18H12.8203C13.0328 18 13.2359 17.9531 13.4203 17.875C11.7328 16.5344 10.3203 14.2281 10.3203 11.25Z",
    fill: "#9999CD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_632_168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.320312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnSelectedLeaderBoardIcon);
export default __webpack_public_path__ + "static/media/unSelectedLeaderBoardIcon.dec9f80badb9914d8e53b75c2df15027.svg";
export { ForwardRef as ReactComponent };